var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.90332V8.95582",
    stroke: "#ADA7A7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0185 1.83325C7.64515 1.83325 4.91348 4.56492 4.91348 7.93825V9.86325C4.91348 10.4866 4.65682 11.4216 4.33598 11.9533L3.17182 13.8966C2.45682 15.0974 2.95182 16.4358 4.27182 16.8758C8.65348 18.3333 13.3926 18.3333 17.7743 16.8758C19.0118 16.4633 19.5435 15.0149 18.8743 13.8966L17.7101 11.9533C17.3893 11.4216 17.1327 10.4774 17.1327 9.86325V7.93825C17.1235 4.58325 14.3735 1.83325 11.0185 1.83325Z",
    stroke: "#ADA7A7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0523 17.2517C14.0523 18.9292 12.6773 20.3042 10.9998 20.3042C10.1656 20.3042 9.3956 19.9559 8.8456 19.4059C8.2956 18.8559 7.94727 18.0859 7.94727 17.2517",
    stroke: "#ADA7A7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.71e5a2b763b1471ecfecac10e85809d3.svg";
export { ForwardRef as ReactComponent };